module.exports = __webpack_public_path__ + "img/icon-setting-dark-mode.16e712f2.svg";